import { TokenVestingSchedule, TokenFinancialData, VestingEvent, TokenVestingResponse, TokenFinancialResponse, VestingEventResponse, TokenDashboardData } from '../types/token'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8787'

// Token Vesting Schedule API
export const tokenVestingAPI = {
  async getAll(): Promise<TokenVestingResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/token-vesting`)
      const data = await response.json()
      return data
    } catch (error) {
      console.error('Error fetching token vesting schedules:', error)
      return {
        success: false,
        error: 'Failed to fetch token vesting schedules'
      }
    }
  },

  async create(vestingSchedule: TokenVestingSchedule): Promise<TokenVestingResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/token-vesting`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(vestingSchedule),
      })
      const data = await response.json()
      return data
    } catch (error) {
      console.error('Error creating token vesting schedule:', error)
      return {
        success: false,
        error: 'Failed to create token vesting schedule'
      }
    }
  },

  async update(id: string, vestingSchedule: TokenVestingSchedule): Promise<TokenVestingResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/token-vesting/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(vestingSchedule),
      })
      const data = await response.json()
      return data
    } catch (error) {
      console.error('Error updating token vesting schedule:', error)
      return {
        success: false,
        error: 'Failed to update token vesting schedule'
      }
    }
  },

  async delete(id: string): Promise<TokenVestingResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/token-vesting/${id}`, {
        method: 'DELETE',
      })
      const data = await response.json()
      return data
    } catch (error) {
      console.error('Error deleting token vesting schedule:', error)
      return {
        success: false,
        error: 'Failed to delete token vesting schedule'
      }
    }
  }
}

// Token Financial Data API
export const tokenFinancialAPI = {
  async getAll(): Promise<TokenFinancialResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/token-financial`)
      const data = await response.json()
      return data
    } catch (error) {
      console.error('Error fetching token financial data:', error)
      return {
        success: false,
        error: 'Failed to fetch token financial data'
      }
    }
  },

  async create(financialData: TokenFinancialData): Promise<TokenFinancialResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/token-financial`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(financialData),
      })
      const data = await response.json()
      return data
    } catch (error) {
      console.error('Error creating token financial data:', error)
      return {
        success: false,
        error: 'Failed to create token financial data'
      }
    }
  },

  async update(id: string, financialData: TokenFinancialData): Promise<TokenFinancialResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/token-financial/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(financialData),
      })
      const data = await response.json()
      return data
    } catch (error) {
      console.error('Error updating token financial data:', error)
      return {
        success: false,
        error: 'Failed to update token financial data'
      }
    }
  },

  async delete(id: string): Promise<TokenFinancialResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/token-financial/${id}`, {
        method: 'DELETE',
      })
      const data = await response.json()
      return data
    } catch (error) {
      console.error('Error deleting token financial data:', error)
      return {
        success: false,
        error: 'Failed to delete token financial data'
      }
    }
  }
}

// Token Dashboard API
export const tokenDashboardAPI = {
  async getDashboardData(): Promise<{ success: boolean; data?: TokenDashboardData; error?: string }> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/token-dashboard`)
      const data = await response.json()
      return data
    } catch (error) {
      console.error('Error fetching token dashboard data:', error)
      return {
        success: false,
        error: 'Failed to fetch token dashboard data'
      }
    }
  },

  async getProjectTokenData(projectId: string): Promise<{ success: boolean; data?: { vestingSchedule: TokenVestingSchedule | null; financialData: TokenFinancialData | null }; error?: string }> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/projects/${projectId}/token-data`)
      const data = await response.json()
      return data
    } catch (error) {
      console.error('Error fetching project token data:', error)
      return {
        success: false,
        error: 'Failed to fetch project token data'
      }
    }
  },

  async getProjectsWithToken(): Promise<{ success: boolean; data?: any[]; error?: string }> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/projects-with-token`)
      const data = await response.json()
      return data
    } catch (error) {
      console.error('Error fetching projects with token data:', error)
      return {
        success: false,
        error: 'Failed to fetch projects with token data'
      }
    }
  }
} 